<div class="modal-header">
  <h4 class="modal-title">{{ 'editCustomArticleNumberListPopup.title.new' | translate }}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form" (submit)="accept()">
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label font-weight-bold">{{'editCustomArticleNumberListPopup.label.name' | translate}}: </label>
        <div class="col-md-8">
          <input class="form-control"
                 type="text"
                 spellcheck="false"
                 appInputAutoFocus
                 formControlName="listName"
                 inputRestricter="^[_.:;,\\! \+\-\(\)\pL\pN]*$"
                 [class.is-invalid]="form.controls.listName.touched && !form.controls.listName.valid">
          <div class="invalid-feedback">
            {{form.controls.listName.errors?.messageKey | translate:{'0':form.controls.listName.errors?.param} }}
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel"
          type="button"
          (mousedown)="close()"
          (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button class="btn btn-primary btn-forward" type="submit" (click)="accept()">{{'global.label.accept' | translate}}</button>
</div>
